import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaPlay, 
  FaTwitch, 
  FaPaintBrush, 
  FaLaptop,
  FaCircle,
} from 'react-icons/fa'; // Importing icons from react-icons

import { FaMagnifyingGlass } from "react-icons/fa6";
import { TbTableShortcut } from "react-icons/tb";
import { MdOutlineWindow } from "react-icons/md";

const Home: React.FC = () => {
  const reasons = [
    {
      title: 'View & Navigate Decks',
      description: 'Easily browse all your decks and switch between them, and control their visibility and status.',
      icon: <MdOutlineWindow size={24} />,
      color: "#4CAF50",
    },
    {
      title: 'Advanced Button Menus',
      description: 'Trigger, Stop, Edit, and Block buttons - all from Deck Hopper.',
      icon: <FaPlay size={24} />,
      color: "#EBB101FF",
    },
    {
      title: 'Create Proxy Buttons',
      description: 'Create button shortcuts in your decks for quick access, without needing to duplicate buttons.',
      icon: <TbTableShortcut size={24} />,
      color: "#03A9F4",
    },
    {
      title: 'Twitch Embed Buttons',
      description: 'Display your Twitch stream or chat alongside your buttons in Deck Hopper.',
      icon: <FaTwitch size={24} />,
      color: "#6441A5",
    },
    {
      title: 'Search & Filter Buttons',
      description: 'View all your buttons at a glance and filter by deck name, trigger, and more.',
      icon: <FaMagnifyingGlass size={24} />,
      color: "#9C27B0",
    },
    {
      title: 'Record Button Activity',
      description: 'Log button activity in real time to track down rogue buttons or debug complex deck setups.',
      icon: <FaCircle size={24} />,
      color: "#FF5722",
    },
    {
      title: 'Customization Options',
      description: 'Personalize everything from auto launch, auto connect, keep awake, deck visibility, and more.',
      icon: <FaPaintBrush size={24} />,
      color: "#2CA4AAFF",
    },
    {
      title: 'Multiplatform Support',
      description: 'Use Deck Hopper on Windows, macOS, Linux, Android and iOS devices. Browser and OBS Dock support included.',
      icon: <FaLaptop size={24} />,
      color: "#91A20FFF",
    },
  ];

  return (
    <div className="flex flex-col items-center justify-center setup-guide bg-dark-blue text-gray-300 p-4 h-full w-[100em] pb-10">
      <h1 className="text-4xl text-center text-white mb-4 mt-4">Meet the ultimate deck app for SAMMI</h1>
      <p className="text-xl text-center text-gray-400 mb-6">
        Elevate your SAMMI experience with Deck Hopper.
      </p>
      <hr className="border-t border-gray-600 w-2/3 mb-2" />

      <div className="text-center mt-8 mx-5 max-w-[70em] w-full">
        <p className="text-lg mb-6">
          Deck Hopper is a powerful deck app designed to seamlessly integrate with SAMMI.
        </p>
        <div className="flex flex-col w-full mb-8 justify-center">
          <div className="relative pb-[56.25%]">
            <iframe
              className="absolute top-0 left-0 w-full h-full rounded-lg shadow-lg"
              src="https://www.youtube.com/embed/lOc9wdYV4E0"
              title="Deck Hopper Overview"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        <h2 className="text-3xl text-white mb-20">Why Choose Deck Hopper?</h2>

        {/* Features Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-14 md:gap-y-16 mt-8 mb-8 cursor-default">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className={`relative border border-gray-400 text-white px-4 py-2 md:py-4 rounded-lg shadow-lg transform transition-transform duration-300 
                hover:bg-gradient-to-r 
                hover:from-[#1c284f80] 
                hover:to-[#194cba] 
                hover:scale-105 
                hover:shadow-2xl 
                group`}
              
            > 
              <div 
                className="absolute -top-8 left-6 p-4 rounded-md text-white shadow-md transition-transform duration-300 group-hover:rotate-12"
                style={{ backgroundColor: reason.color || '#2563eb' }}
              >
                {reason.icon}
              </div>
              <div className="mt-8">
                <h3 className="text-lg font-bold mb-2">{reason.title}</h3>
                <p className="text-sm text-gray-400">{reason.description}</p>
              </div>
            </div>
          ))}
        </div>

        <p className="text-sm text-gray-500 mb-6">Some advanced features require Pro version.</p>
        <div className="text-center mb-8 text-gray-300">
          Created by the founder of SAMMI and a former developer, as an independent initiative.
        </div>

        <div className="flex gap-4 justify-center">
          <Link to="/download">
            <button className="px-6 py-3 rounded-md bg-blue-600 text-white font-semibold hover:bg-blue-700 transition duration-300">
              Download Now
            </button>
          </Link>
          <Link to="/upgrade">
            <button className="px-6 py-3 rounded-md bg-purple-600 text-white font-semibold hover:bg-purple-700 transition duration-300">
              Upgrade to Pro
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home;
